import { Module } from 'vuex';
import { StateInterface } from '../index';

import state, { SharedState } from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';


const SharedModule: Module<SharedState, StateInterface> = {
    namespaced: true,
    actions,
    getters,
    mutations,
    state
}


export default SharedModule;